import React, {useState} from 'react';
import styles from './reject-transfer-modal-content.module.scss';
import {Row, Col, Button, Spinner} from 'react-bootstrap';
import SuccessModalContent
  from "../../../../../securities/security-details/components/modal-content-success/modal-content-success";
import {
  TRANSFER_REJECT_ERROR,
  TRANSFER_REJECT_SUCCESS, TRANSFER_REJECTED, TRANSFER_REJECTED_FOR_EDIT,
} from "../../../../../../helpr/constants";
import ErrorModalContent
  from "../../../../../securities/security-details/components/modal-content-error/modal-content-error";
import {useValidation} from "../../../../../../hooks/use-validation";
import {DropDown} from "../../../../../../components/form/form";
import {required} from "../../../../../../helpr/generic-validation-rules";
import SecondaryMarketService from "../../../../../../services/secondary-market-service";
import {getTaxStatusTypes} from "../../../../../../helpr/transferFormData";

const RejectTransferModalContent = ({context, onBack, onClose}) => {
  //Transfer instruction result variables
  const SUCCESS_TITLE = "TRANSFER REJECTED";
  const ERROR_TITLE = "A PROBLEM OCCURRED";
  const [ page, setPage ] = useState(0);

  //Service call states
  const { selectedTransfer, setTransferList } = context;
  const [ rejectFieldsState, setRejectFieldsState ] = useState({
    transferDate: false,
    settlementDate: false,
    fromRegistryBpId: false,
    fromRegistryAccountNumber: false,
    toType: false,
    toDepositoryBpId: false,
    toDepositoryAccountNumber: false,
    toRegistryBpId: false,
    toRegistryAccountNumber: false
  });
  const [ loading, setLoading] = useState(false);
  const secondaryMarketService = new SecondaryMarketService();

  //Validator
  const rejectInfoState = useValidation(
    rejectInfoValidator,
    rejectInfoObj({
      rejectReason: ''
    }),
    {border: '1px solid red'});
  const { validate, getDropdownProps, getField } = rejectInfoState;

  const reject = async () => {
    const { formState, isFormValid } = validate();
    const rejectFields = Object.entries(rejectFieldsState)
      .filter(f => f[1])
      .map(f => ({ key: f[0], value: retrieveRejectFieldValue(f[0])}));
    formState['rejectFields'] = rejectFields;
    if(!isFormValid){
      return
    }
    setLoading(true);
    try {
      const status = getField('rejectReason') === 'Other incorrect information'
        ? TRANSFER_REJECTED_FOR_EDIT : TRANSFER_REJECTED;
      await secondaryMarketService.rejectTransfer(selectedTransfer.current.transferId, formState, status);
      setTransferList(prev => {
        const updatedList = prev.map(p => {
          if(p.transferId === selectedTransfer.current.transferId){
            return {
              ...p,
              transferStatus: status
            }
          }
          return p
        });
        return updatedList;
      });
      setPage(1);
    }catch(error){
      setPage(2);
    }finally {
      setLoading(false);
    }
  }
  const renderRejectionResult = () => {
    switch(page){
      case 1:
        return <SuccessModalContent title={SUCCESS_TITLE} message={TRANSFER_REJECT_SUCCESS} onClose={onClose}/>
      case 2:
        return <ErrorModalContent title={ERROR_TITLE} message={TRANSFER_REJECT_ERROR} onClose={onClose}/>
      default:
    }
  }

  const getRejectReason = () => {
    return [
      { name: 'Incorrect Name', value: 'Incorrect Name' },
      { name: 'Other incorrect information', value: 'Other incorrect information' }
    ]
  }

  const retrieveRejectFieldValue = key => getRejectFields()[0]
    .concat(getRejectFields()[1])
    .filter(t => t.key === key)[0]?.value;

  const getRejectFields = () => {
    return [
      [
        {'key': 'transferDate', 'value': 'Transfer Date'},
        {'key': 'settlementDate', 'value': 'Settlement Date'},
        {'key': 'fromRegistryBpId', 'value': 'From - Registry BPID'},
        {'key': 'fromRegistryAccountNumber', 'value': 'From - Registry Account Number'}
      ],
      [
        {'key': 'toType', 'value': 'To - Destination/Settlement Location'},
        {'key': 'toDepositoryBpId', 'value': 'To - Depository BPID'},
        {'key': 'toDepositoryAccountNumber', 'value': 'To - Depository Account Number'},
        {'key': 'toRegistryBpId', 'value': 'To - Registry BPID'},
        {'key': 'toRegistryAccountNumber', 'value': 'To - Registry Account Number'}
      ]
    ]
  }

  const rejectedFieldsChange = key => {

    console.log(rejectFieldsState, key);
    setRejectFieldsState({
      ...rejectFieldsState,
      [key]: !rejectFieldsState[key]
    })
  }

  return page === 0 ? (
    <div className={styles['reject-transfer-modal-content']}>
      <Row>
        <Col lg={{offset: 1, span: 10}}>
          <Row>
            <Col lg={12}>
              <DropDown inputProps={getDropdownProps('rejectReason')} values={getRejectReason()}>
                Reason for Rejection
              </DropDown>
            </Col>
          </Row>
          { getField('rejectReason') === 'Other incorrect information'
            ? (
              <Row>
                <Col lg={6}>
                  {
                    getRejectFields()[0].map(f => {
                      return <div><input type="checkbox" onChange={()=> rejectedFieldsChange(f.key)} />{' '}{f.value}</div>
                    })
                  }
                </Col>
                <Col lg={6}>
                  {
                    getRejectFields()[1].map(f => {
                      return <div><input type="checkbox" onChange={() => rejectedFieldsChange(f.key)}/>{' '}{f.value}</div>
                    })
                  }
                </Col>
              </Row>
            ) : ''
          }
          <Row className={styles['button-row']}>
            <Col xs={6} lg={6}>
              <div className={styles['back-button']}>
                <Button variant="secondary" onClick={() => onBack()}>
                  BACK
                </Button>
              </div>
            </Col>
            <Col xs={6} lg={6}>
              <div className={styles['reject-button']}>
                <Button disabled={loading} onClick={() => reject()}>
                  {loading ? <Spinner size="sm" animation="border"/> : 'REJECT'}
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : renderRejectionResult()
}

const rejectInfoObj = obj => {
  return {
    fields: {
      rejectReason: {
        value: obj.rejectReason,
        style: {}
      }
    },
    dynamicFields: {}
  }
}

const rejectInfoValidator = {
  fields: {
    rejectReason: [required]
  },
  dynamicFields: {}
}

export default RejectTransferModalContent;
